import { makeAutoObservable } from 'mobx'

import { contractController } from '@/controller/contract.controller'
import commonRepo from '@/repository/common.repo'
import { downloadFileByUrl } from '@/utils/download'
import { toastError, toastNotice, toastSuccess } from '@/utils/toast'

class B2gContractService {
  // 계약서 pdf 생성 상태
  pdfStatus?: res.NotificationWithStatus | null = null
  constructor() {
    makeAutoObservable(this)
  }
  setPdfStatus(status) {
    this.pdfStatus = status
  }
  get isGenerating() {
    return this.pdfStatus?.status === 'GENERATING'
  }
  async downloadContractPdf() {
    try {
      let _pdfUrl: string = ''
      if (commonRepo.b2gContract?.pdfUrl) {
        _pdfUrl = commonRepo.b2gContract?.pdfUrl
      } else {
        if (!this.pdfStatus) return
        if (this.pdfStatus.status === 'GENERATING') {
          toastNotice('PDF 생성 중입니다. 잠시만 기다려주세요.')
          return
        }
        if (this.pdfStatus.status === 'FAIL') {
          toastError('계약서 다운로드에 실패했습니다.')
          return
        }
        const { pdfUrl } = await contractController.downloadContractPdf()
        if (pdfUrl) {
          _pdfUrl = pdfUrl
        }
      }
      const fileName =
        _pdfUrl?.substring(_pdfUrl.lastIndexOf('/') + 1) || '스쿨플랫_정식계약내역서.pdf'

      await downloadFileByUrl(_pdfUrl, {
        fullFileName: fileName,
      })
      toastSuccess('계약서 다운로드가 완료되었습니다.')
    } catch (error) {
      toastError('계약서 다운로드에 실패했습니다.')
    }
  }
}

const b2gContractService = new B2gContractService()
export default b2gContractService
